// Main Cashier State

export default {
  mainCashierList: [],
  mainCashierInfo: {}
}
